import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from "@mui/material";
import { ReducedButtonColorTheme, segmentedButtonColors } from "src/components/button/ButtonUtils";
import { styled } from "src/styles/fpp-theme/fppStyled";
import React from "react";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export interface SenecSegmentedButtonProps extends ToggleButtonGroupProps {
    colorTheme?: ReducedButtonColorTheme;
    selectedValue: string;
    values: string[];
    onChange: (event: React.MouseEvent<HTMLElement>, value: string) => void;
}

export const SenecSegmentedButton = ({
    colorTheme = "light",
    selectedValue,
    values,
    onChange,
    ...rest
}: SenecSegmentedButtonProps) => {
    return (
        <StyledToggleButtonGroup colorTheme={colorTheme} exclusive value={selectedValue} onChange={onChange} {...rest}>
            {values.map((value) => (
                <ToggleButton key={value} value={value} disableRipple>
                    {value}
                </ToggleButton>
            ))}
        </StyledToggleButtonGroup>
    );
};

interface StyledToggleButtonGroupProps extends ToggleButtonGroupProps {
    colorTheme: ReducedButtonColorTheme;
}

const StyledToggleButtonGroup = styled(ToggleButtonGroup, {
    shouldForwardProp: (prop) => prop !== "colorTheme",
})<StyledToggleButtonGroupProps>(({ theme, colorTheme }: { theme: SenecFPPTheme; colorTheme: ReducedButtonColorTheme }) => ({
    ...segementedButtonGroupStyles(theme, colorTheme),
}));

export const segementedButtonGroupStyles = (theme: SenecFPPTheme, colorTheme: ReducedButtonColorTheme) => {
    const palette = segmentedButtonColors(theme);
    const senecFontStyle = theme.typography.s1Medium;

    return {
        borderRadius: "20px",
        border: "0px",
        padding: "4px",
        height: "40px",
        gap: "2px",
        backgroundColor: palette[colorTheme].primaryMain,
        "& .MuiToggleButton-root": {
            color: palette[colorTheme].secondaryText,
            height: "32px",
            borderRadius: "16px",
            border: "0px",
            padding: "10px 12px",
            minWidth: "80px",
            width: "100%",
            textWrapMode: "nowrap",
            "&.MuiToggleButtonGroup-grouped": {
                borderRadius: "16px",
            },
            "&.Mui-selected": {
                backgroundColor: theme.palette.white.main,
                color: palette[colorTheme].primaryText,
                "&:hover": {
                    backgroundColor: theme.palette.white.main,
                },
            },
            "&:hover": {
                backgroundColor: palette[colorTheme].secondaryMain,
            },
            ...senecFontStyle,
        },
    };
};
